import { render, staticRenderFns } from "./succes.vue?vue&type=template&id=8ad14a88&lang=pug"
import script from "./succes.vue?vue&type=script&lang=js"
export * from "./succes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports